import { Form } from "antd";

export function useBloqueioCampos({
  form,
  nomePrefix = [],
  modoSomenteLeitura = false,
  desabilitarCampos = false,
  recadastramento = false,
}) {
  const alteracaoCadastro = Form.useWatch(
    [...nomePrefix, "alteracaoCadastro"],
    form
  );

  const camposBloqueados =
    modoSomenteLeitura ||
    desabilitarCampos ||
    (recadastramento && !alteracaoCadastro);

  return {
    camposBloqueados,
    alteracaoCadastro,
  };
}
